/**
 * @generated SignedSource<<7ef2b9012000ffa819d8abda70596348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoWrapper_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingAndReturns_item">;
  readonly " $fragmentType": "PdpSharedShippingInfoWrapper_item";
};
export type PdpSharedShippingInfoWrapper_item$key = {
  readonly " $data"?: PdpSharedShippingInfoWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingAndReturns_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e4eccdb342b6605b519849984c4339a5";

export default node;
